import React from "react";
import styles from "./tag.module.scss";
import classNames from "classnames";

type Props = {
  indicatorValue: string | number;
  title: string;
  color?: "grey" | "warning" | "error" | "default";
  noContainer?: boolean;
};

const Tag = ({ indicatorValue, title, color = "default", noContainer = false }: Props) => {
  return (
    <div className={classNames(styles.tag, noContainer && styles.noContainer)}>
      <span className={classNames(styles.permissionCount, styles[color])}>{indicatorValue}</span> {title}
    </div>
  );
};

export default Tag;
